import React from 'react';
import { session } from '../../../services/session';
import { getClass } from '../../../utils/component-helpers';

import './strategy-selection.scss';

const StrategySelection = ({
  strategyType,
  selectStrategyType,
  strategyValueInput,
  updateStrategyValue,
  validateStrategyInput,
  pricingModel,
  togglePaymentModel,
  paymentModelVisible,
  paymentToggleVisible,
  hasError,
}) => {
  const errorMessage = hasError ? (
    <div className="error-label">{`Invalid ${strategyType.toUpperCase()}`}</div>
  ) : null;

  const paymentModelToggle =
    session.isAdminView && paymentToggleVisible ? (
      <div className="payment-model-toggle">
        <div
          className={getClass('slider', {
            selected: paymentModelVisible,
          })}
          onClick={() => togglePaymentModel()}
        >
          <span />
        </div>
        Set different publisher payment model
      </div>
    ) : null;

  return (
    <div className="strategy-selection-container">
      <div className="strategy-label">Pricing Strategy</div>
      <div
        className={getClass('roi-strategy', {
          selected: strategyType === 'roi',
          show: pricingModel === 'EPP',
        })}
        onClick={() => selectStrategyType('roi')}
      >
        ROI
      </div>
      <div
        className={getClass('cpc-strategy', {
          selected: strategyType === 'cpc',
        })}
        onClick={() => selectStrategyType('cpc')}
      >
        CPC
      </div>
      <div className="is">is</div>
      <input
        className={`strategy-value-input${hasError ? ' error' : ''}`}
        placeholder={`Set ${strategyType.toUpperCase()}`}
        value={strategyValueInput}
        onChange={event => updateStrategyValue(event)}
        onBlur={() => validateStrategyInput(strategyValueInput)}
      />
      {paymentModelToggle}
      {errorMessage}
    </div>
  );
};

export default StrategySelection;
